module.exports = __webpack_public_path__ + "img/TX.9c082c4d.svg";